import { datadogRum } from '@datadog/browser-rum';
import { loggerConfig } from 'config';

// @see https://github.com/DataDog/rum-react-integration-examples?tab=readme-ov-file
// @see https://www.datadoghq.com/blog/datadog-rum-react-components/
// @see https://docs.datadoghq.com/real_user_monitoring/browser/advanced_configuration/?tab=npm

export function initialize() {
    if (typeof window === 'undefined' || !loggerConfig.LOGGING_ENABLED) {
        return;
    }

    datadogRum.init({
        applicationId: loggerConfig.SERVICE.APPLICATION_ID,
        clientToken: loggerConfig.SERVICE.CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'hosted-ui',
        // Specify a version number to identify the deployed version of your application in Datadog
        version: `${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_ENV}`,
        sessionSampleRate: 100,
        sessionReplaySampleRate: loggerConfig.DATADOG_SESSIONS_ENABLED ? 100 : 0, // Disable's session replays on prod
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        storeContextsAcrossPages: true,
        defaultPrivacyLevel: 'mask-user-input',
        env: process.env.REACT_APP_ENV,
    });
}

export const setUser = ({ uuid, first_name, last_name, company_name, company_id }) => {
    if (!loggerConfig.LOGGING_ENABLED) {
        return;
    }

    datadogRum.setUser({
        id: uuid,
        name: `${first_name} ${last_name}`,
        company: { name: company_name, uuid: company_id },
    });
};
export const setUserProperty = loggerConfig.LOGGING_ENABLED ? datadogRum.setUserProperty : () => {};
